import {KatButton, KatTabs, KatTab, KatDivider, KatFlashbar, KatSpinner} from "@amzn/katal-react";
import React, {useEffect, useRef, useState} from "react";
import {FormInput} from "src/view/style/modelTraining/form_input_styles";
import {
    FIELDS_REQUIRED_MESSAGE,
    NAMESPACE_UPDATE_FAILED,
    NAMESPACE_UPDATE_SUCCESS,
    REGISTER_PACKAGE_FAILED,
    REGISTER_PACKAGE_SUCCESS
} from "src/view/modelTraining/constants";
import {isEmpty, setIfMounted} from "src/utils/common_utils";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {usernameSelector} from "src/control/selectors/commons/user_selectors";
import {
    loadModelTrainingNamespace,
    updateModelTrainingNamespace,
    registerCodePackage
} from "src/control/actions/modelTraining/namespace_actions";

import {START_REGISTER_CODE_PACKAGE_LOADER, START_UPDATE_NAMESPACE_LOADER} from "src/control/actions/action_types";
import {updateModelTrainingNamespaceSelector, registerCodePackageSelector, namespaceSelector} from "src/control/selectors/modelTraining/model_training_selectors";
import {Heading} from "src/view/style/home_styles";

const UpdateNamespace = () => {
    const params: any = useParams()
    const dispatch = useDispatch();

    let userId = useSelector(usernameSelector);
    let updateNamespaceState = useSelector(updateModelTrainingNamespaceSelector)
    let fetchedNamespace = useSelector(namespaceSelector)

    let _isMounted = useRef(true);
    const [namespaceName, setNamespaceName] = useState('')
    const [prodAccountId, setProdAccountId] = useState('')
    const [gammaAccountId, setGammaAccountId] = useState('')
    const [expAccountId, setExpAccountId] = useState('')
    const [pipeline, setPipeline] = useState('')
    const [codePackageName, setCodePackageName] = useState('')
    let registerCodePackageState = useSelector(registerCodePackageSelector);

    let displayMessage = (updateNamespaceState.isError) || (updateNamespaceState.isSuccess)
    let registerPackageMessage = (registerCodePackageState.isError) || (registerCodePackageState.isSuccess)

    useEffect(() => {
        _isMounted.current = true;
    });

    useEffect(() => {
        return () => {
            _isMounted.current = false;
        }
    });

    const getMessage = () => {
        if(updateNamespaceState.isError){
            return NAMESPACE_UPDATE_FAILED
        } else if (updateNamespaceState.isSuccess) {
            return NAMESPACE_UPDATE_SUCCESS
        }
        return ""
    }

    const getRegisterPackageMessage = () => {
        if(registerCodePackageState.isError){
            return REGISTER_PACKAGE_FAILED
        } else if (registerCodePackageState.isSuccess) {
            return REGISTER_PACKAGE_SUCCESS
        }
        return ""
    }

    const loadNamespace = () => {
        dispatch(loadModelTrainingNamespace(params.teamId, params.namespaceId, []))
    }

    const initializeStates = () => {
        setIfMounted(_isMounted.current, setNamespaceName, fetchedNamespace.namespaceData.namespace)
        setIfMounted(_isMounted.current, setPipeline, fetchedNamespace.namespaceData.pipelineName)
        setIfMounted(_isMounted.current, setExpAccountId, fetchedNamespace.namespaceData.accountTypeMap.experimentation)
        setIfMounted(_isMounted.current, setGammaAccountId, fetchedNamespace.namespaceData.accountTypeMap.gamma)
        setIfMounted(_isMounted.current, setProdAccountId, fetchedNamespace.namespaceData.accountTypeMap.prod)
    }

    useEffect(() => {
        if (_isMounted.current) {
            loadNamespace()
        }
    }, [userId, params.teamId, params.namespaceId, dispatch]);

    useEffect(() => {
            if (_isMounted.current) {
                initializeStates()
            }
       }, [fetchedNamespace]);

    const onSubmit = (event: any) => {
        event.preventDefault()
        if (isEmpty(namespaceName) ||
            isEmpty(pipeline) ||
            isEmpty(expAccountId)) {
            alert(FIELDS_REQUIRED_MESSAGE)
            return
        }
        dispatch({type: START_UPDATE_NAMESPACE_LOADER})
        dispatch(updateModelTrainingNamespace(params.teamId, params.namespaceId, {
            requestedBy: userId,
            accountTypeMap: {
                experimentation: expAccountId,
                gamma: gammaAccountId,
                prod: prodAccountId
            }
        }))
    }

    const onRegister = (event: any) => {
        event.preventDefault()
        if (isEmpty(codePackageName)) {
            alert(FIELDS_REQUIRED_MESSAGE)
            return
        }
        dispatch({type: START_REGISTER_CODE_PACKAGE_LOADER})
        dispatch(registerCodePackage(params.teamId, params.namespaceId, {
            namespaceId : params.namespaceId,
            teamId : params.teamId,
            packageName: codePackageName,
            requestedBy: userId,
            namespaceType : "Runway"
        }))
    }

    return (
        <div className="UpdateNamespace">
            {displayMessage ?
                <KatFlashbar variant={updateNamespaceState.isSuccess ? "success" : "danger"}
                             header={getMessage()}
                >
                </KatFlashbar>
                : updateNamespaceState.startLoader ? <KatSpinner/>: null
            }
            <form className='UpdateNamespace-form' onSubmit={onSubmit}>
                <FormInput
                    label="Namespace name*"
                    type='text'
                    value={namespaceName}
                    onChange={(event: any) => setNamespaceName(event.target.value)}
                    required
                    disabled
                />
                <br/>
                <FormInput
                    label="Pipeline Name *"
                    type='text'
                    placeholder='Pipeline Name'
                    value={pipeline}
                    onChange={(event: any) => setPipeline(event.target.value)}
                    required
                    disabled
                />
                <br/>
                <KatDivider variant="eastern"/>
                <KatTabs selected="Experimentation">
                    <KatTab tabId="Experimentation" label="Experimentation">
                        <FormInput
                            label="Account Id *"
                            placeholder='Experimentation Account Id'
                            type='text'
                            value={expAccountId}
                            onChange={(event: any) => setExpAccountId(event.target.value)}
                            required
                            disabled = {!isEmpty(expAccountId)}
                        />
                        <br/>
                    </KatTab>
                    <KatTab tabId="Gamma" label="Gamma">
                        <FormInput
                            label="Account Id"
                            type='text'
                            placeholder='Gamma Account Id'
                            value={gammaAccountId}
                            onChange={(event: any) => setGammaAccountId(event.target.value)}
                            disabled = {!isEmpty(gammaAccountId)}
                        />
                        <br/>
                    </KatTab>
                    <KatTab tabId="Prod" label="Prod">
                        <FormInput
                            label="Account Id"
                            type='text'
                            placeholder='Prod Account Id'
                            value={prodAccountId}
                            onChange={(event: any) => setProdAccountId(event.target.value)}
                            disabled = {!isEmpty(prodAccountId)}
                        />
                        <br/>
                    </KatTab>
                </KatTabs>
                <br/>
                <KatButton type="submit" label="Update" variant="primary" size="base"
                           disabled={isEmpty(userId) || isEmpty(namespaceName)}/>
            </form>
            <div>
                <KatDivider variant="zircon"/>
            </div>
            <Heading>
                Register Code Package
            </Heading>
            <form className='RegisterCodePackage-form' onSubmit={onRegister}>
                {registerPackageMessage ?
                    <KatFlashbar variant={registerCodePackageState.isError ? "danger" : "success"}
                                 header={getRegisterPackageMessage()}>
                    </KatFlashbar>
                    : registerCodePackageState.startLoader ? <KatSpinner/> : null
                }
                <FormInput
                    label="Package Name *"
                    type='text'
                    tooltipText="Code package name from code.amazon.com"
                    value={codePackageName}
                    onChange={(event: any) => setCodePackageName(event.target.value)}
                    required
                />
                <br/>
                <KatButton type="submit" label="Register" variant="primary" size="base"
                           disabled={isEmpty(userId)}/>
            </form>
        </div>
    );
}

export default UpdateNamespace;